import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BOOKSY_URL } from "@/lib/config";

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <section id="services" className="bg-[#050505] py-24 md:py-32 px-4 md:px-8 relative">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-12 bg-[#FF3333]" />
              <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF3333]">01 — Services</span>
            </div>
            <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none">
              The <span className="italic text-[#FF3333]">Menu</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md font-light leading-relaxed">
            Every service starts with a consultation. We take the time to get it right — because
            you only get one fresh cut at a time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-white/10">
          {services.map((s, idx) => (
            <a
              key={s.id}
              href={BOOKSY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`service-${s.id}`}
              className="block border-b border-r border-white/10 p-8 md:p-10 hover:bg-white/[0.03] transition-colors group cursor-pointer"
            >
              <div className="flex items-start justify-between gap-6 mb-4">
                <div className="flex items-center gap-4">
                  <span className="font-display text-sm text-white/30">0{idx + 1}</span>
                  <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight group-hover:text-[#FF3333] transition-colors">
                    {s.name}
                  </h3>
                </div>
                <div className="text-right shrink-0">
                  <div data-testid={`service-price-${s.id}`} className="font-mono text-3xl md:text-4xl font-bold text-[#CCFF00]">
                    ${s.price.toFixed(0)}
                  </div>
                  <div className="text-xs tracking-[0.2em] uppercase text-white/40 mt-1">
                    {s.duration_min} min
                  </div>
                </div>
              </div>
              <p className="text-white/60 font-light leading-relaxed">{s.description}</p>
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-white/40 group-hover:text-[#FF3333] transition-colors">
                → Book on Booksy
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
